import "../../../assets/scss/components/sections/home/features-5.scss";
import { Col, Container, Image, Row } from "react-bootstrap";

import icon1 from "../../../assets/images/home/feature5-icon-1.svg";
import icon2 from "../../../assets/images/home/feature5-icon-2.svg";
import icon3 from "../../../assets/images/home/feature5-icon-3.svg";
import feature5img from "../../../assets/images/home/feature-3.svg";
import Btn from "../../templates/button";

const Features5 = () => {
  return (
    <div className="features-5-section">
      <Container>
        <div className="features-5">
          <div className="content">
            <Row>
              <Col lg={6}>
                <div className="left-content">
                  <div className="heading">
                    <h3 className="heading-3">
                      Instantly See How Your Resume Measures Up
                    </h3>
                    <p className="paragraph-small-regular">
                      Get a detailed analysis of how well your resume aligns
                      with job requirements
                    </p>
                  </div>
                  <div className="features-list">
                    <div className="list-item">
                      <div className="list-icon">
                        <div className="icon icon-1">
                          <Image src={icon1} />
                        </div>
                      </div>
                      <div className="text">
                        <h4 className="heading-6">Relevance</h4>
                        <p className="paragraph-small-regular">
                          Tracks essential keywords from the job description
                        </p>
                      </div>
                    </div>
                    <div className="list-item">
                      <div className="list-icon">
                        <div className="icon icon-2">
                          <Image src={icon2} />
                        </div>
                      </div>
                      <div className="text">
                        <h4 className="heading-6">Alignment</h4>
                        <p className="paragraph-small-regular">
                          Highlights critical skills and experiences
                        </p>
                      </div>
                    </div>
                    <div className="list-item">
                      <div className="list-icon">
                        <div className="icon icon-3">
                          <Image src={icon3} />
                        </div>
                      </div>
                      <div className="text">
                        <h4 className="heading-6">Coherence</h4>
                        <p className="paragraph-small-regular">
                          Assesses alignment with the job's context
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className=" text-center text-lg-start">
                    <Btn
                      text="Analyze Your Resume"
                      class="btn-secondary"
                      handle={() => {
                        window.location.href =
                          process.env.REACT_APP_APP_REGISTER_URL;
                      }}
                    />
                  </div>
                </div>
              </Col>
              <Col lg={6}>
                <div className="right-content">
                  <div className="image">
                    <Image src={feature5img} />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Features5;
